import type {
  BizminerImprovementLever,
  BizminerPillarInsight,
} from "@/types/serializers";
import { MarkdownContent } from "@/components/MarkdownContent";
import { Card } from "@/components/ui/card";
import ImprovementLeverLayout from "./_components/ImprovementLeverLayout";

interface DeepDiveProps {
  pillar_insight: BizminerPillarInsight;
  improvement_lever: BizminerImprovementLever;
  current_tab: string;
}

export default function DeepDive({
  pillar_insight,
  improvement_lever,
  current_tab,
}: DeepDiveProps) {
  return (
    <ImprovementLeverLayout
      pillar_insight={pillar_insight}
      improvement_lever={improvement_lever}
      current_tab={current_tab}
    >
      <div className="space-y-6">
        <Card className="p-6">
          <MarkdownContent
            content={improvement_lever.deep_dive || "No deep dive information available"}
          />
        </Card>
      </div>
    </ImprovementLeverLayout>
  );
}
